// extracted by mini-css-extract-plugin
export var leftAlign = "_1h-2";
export var popper = "_1h-0";
export var subtitle = "_1h-1";